var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.771,
    height: 144.771,
    viewBox: "0 0 144.771 144.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M145.333,72.948A72.385,72.385,0,1,1,72.948.563,72.385,72.385,0,0,1,145.333,72.948ZM64.575,111.275,118.281,57.57a4.67,4.67,0,0,0,0-6.6l-6.6-6.6a4.67,4.67,0,0,0-6.6,0l-43.8,43.8L40.824,67.711a4.67,4.67,0,0,0-6.6,0l-6.6,6.6a4.67,4.67,0,0,0,0,6.6l30.355,30.355a4.67,4.67,0,0,0,6.6,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#05b805"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.318e31b30143ec98d2ae713fb044657d.svg";
export { ForwardRef as ReactComponent };